export class TextRenderConfig {
}
TextRenderConfig.maxCanvasWidth = 4096;
TextRenderConfig.atlasWidth = 1024;
TextRenderConfig.atlasGridW = 16;
TextRenderConfig.standardFontSize = 32;
TextRenderConfig.noAtlas = false;
TextRenderConfig.forceSplitRender = false;
TextRenderConfig.forceWholeRender = false;
TextRenderConfig.scaleFontWithCtx = true;
TextRenderConfig.maxFontScale = 3;
TextRenderConfig.fontScale = 1;
